import React from "react";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { handleEncoding } from "../../utils/handleEncoding";

function Product({
  popular = null,
  title,
  description,
  image,
  productPath,
  productPrice,
  productOldprice,
  productId,
  productLink,
}) {
  return (
    <article className="p-4 w-1/2 md:w-1/3 lg:w-1/4 mb-4">
      <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 h-full flex flex-col">
        <div className="product-thumbnail mb-3 p-4 bg-gray-50 rounded-t-lg overflow-hidden">
          {image ? (
            <LazyLoadImage 
              alt={title} 
              src={image}
              className="w-full h-auto object-contain aspect-square"
            />
          ) : (
            <div className="border border-gray-200 w-full aspect-square flex items-center justify-center bg-white rounded">
              <span className="text-gray-400 text-sm">Intet billede</span>
            </div>
          )}
        </div>
        
        <div className="px-4 pb-4 flex flex-col flex-grow">
          <Link to={productPath} className="block mb-2 hover:text-green-700 transition-colors">
            <h2 className="line-clamp-2 font-bold text-base leading-snug" style={{ minHeight: 44 }}>
              {handleEncoding(title)}
            </h2>
          </Link>
          
          {description && (
            <p className="text-sm text-gray-600 line-clamp-2 h-6 truncate leading-relaxed">
              {handleEncoding(description)}
            </p>
          )}
          
          <div className="mt-auto">
            <div className="mb-3">
              {productOldprice && Number(productOldprice) > Number(productPrice) ? (
                <p className="text-sm text-gray-500 line-through mb-1">{productOldprice} DKK</p>
              ) : (
                <div className="h-5"></div>
              )}
              <p className="font-bold text-lg text-gray-900">{productPrice} DKK</p>
            </div>
            
            <Link
              to={popular ? productPath : `/redirect/${productId}`}
              className="btn font-bold text-center block w-full hover:opacity-90 transition-opacity"
              aria-label={`Læs mere om ${handleEncoding(title)}`}
            >
              Læs mere
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}

export default Product;
